import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Upload, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { uploadInvoiceDocument } from '@/lib/inbox/upload';

// Shared "Upload invoice" action (Invoice Inbox + Purchasing). Manager+ only; uploads, registers, extracts, opens the standard review page.
export function UploadInvoiceButton({ variant = 'outline', className = '', testId = 'upload-invoice-button' }) {
  const { organisationId, role } = useAuth(); const nav = useNavigate();
  const ref = useRef(null); const [step, setStep] = useState(null);
  if (!['owner', 'admin', 'manager'].includes(role || '')) return null;
  const onFile = async (e) => {
    const file = e.target.files?.[0]; e.target.value = ''; if (!file) return;
    setStep('Starting…');
    try {
      const r = await uploadInvoiceDocument(organisationId, file, setStep);
      if (r.existing) toast.info(r.state === 'invoiced' ? 'This exact document was already uploaded and turned into an invoice — opening it.' : 'This exact document is already in the Inbox — opening the existing item.');
      else if (r.extracted) toast.success('Document read — check the details and lines, then create the draft.');
      else toast.warning('The document was uploaded but could not be read automatically. Enter the details and lines manually, or try “Re-read document”.');
      nav(`/invoices/${r.importId}`);
    } catch (err) { toast.error(err.message || 'Upload failed'); } finally { setStep(null); }
  };
  return (
    <>
      <input ref={ref} type="file" accept="application/pdf,image/*,.pdf,.heic" capture="environment" className="hidden" data-testid={`${testId}-input`} onChange={onFile} />
      <Button variant={variant} className={className} data-testid={testId} disabled={!!step} onClick={() => ref.current?.click()}>
        {step ? <><Loader2 size={14} className="mr-1 animate-spin" />{step}</> : <><Upload size={14} className="mr-1" /> Upload invoice</>}
      </Button>
    </>
  );
}
